<app-receipt
  [display_columns]="displayedColumns"
  [staged_receipts]="staged_receipts"
  [sse_name]="'TransferReceipt'"
  [upload_field_text]="'receipt.uploadTransferReceipt' | translate"
  [validation_schema]="validation_s"
  [upload_handler]="client_proc"
  [lookupPermanent]="look_today"
  [callme]="lookup_permanent"
  [get_paginated_data]="get_paginated_data_c"
  [available_filters]="availablefilters"
>
</app-receipt>
